import {SkeletonGrid, SkeletonTile} from './KpiPanelSkeleton.styled'

type KpiPanelSkeletonProps = {
  /** How many placeholder tiles to render — the live tile count for the node's role, so the
   * skeleton grid matches the real grid's footprint and the tiles swap in with no layout jump. */
  count: number
}

/**
 * Placeholder tile grid shown while a KPI panel's content is being prepared (PT-5716). It mirrors
 * the live {@link PanelBody} grid exactly — same columns, same tile count — so the panel never
 * looks frozen and there is no reflow when the real tiles arrive.
 *
 * @param count - Number of skeleton tiles to render (the role's live tile count).
 */
export const KpiPanelSkeleton = ({count}: KpiPanelSkeletonProps) => (
  <SkeletonGrid data-testid="kpi-panel-skeleton" aria-hidden="true">
    {Array.from({length: count}, (_, index) => (
      <SkeletonTile key={index} data-testid="kpi-skeleton-tile" />
    ))}
  </SkeletonGrid>
)
